document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-size-chart]").forEach((root) => {
    const inRadio = root.querySelector("#sc-in");
    const cmRadio = root.querySelector("#sc-cm");
    const table = root.querySelector(".sc-table");

    if (!inRadio || !cmRadio || !table) return;

    const valueCells = table.querySelectorAll('td[data-in][data-cm]');

    function applyUnit(unit) {
      valueCells.forEach((td) => {
        const val = td.getAttribute(unit === "cm" ? "data-cm" : "data-in");
        if (val != null) td.textContent = val;
      });
    }

    // On toggle
    inRadio.addEventListener("change", () => {
      if (inRadio.checked) applyUnit("in");
    });

    cmRadio.addEventListener("change", () => {
      if (cmRadio.checked) applyUnit("cm");
    });

    // Initial state
    applyUnit(inRadio.checked ? "in" : "cm");
  });
});
